import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const TechnicalError = () => {
	useTitle("Technischer Fehler");

	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Technischer Fehler"
			description={
				<>
					Leider ist ein technischer Fehler
					aufgetreten. <br />
					Sie können Ihre E-Mail-Adresse auch im{" "}
					<a
						href={
							APP_CONSTANTS.LINK
								.KUNDENCENTER
						}
						className={"link"}
						tabIndex={1}
					>
						Kundencenter
					</a>{" "}
					bestätigen.
				</>
			}
			buttons={undefined}
			icon={icons[0]}
		></Container>
	);
};

export default TechnicalError;
